import React, { Component } from 'react';
import axios from '~/data/http/axios';
import ButtonSelect from '~/Common-Objects/UI/Forms/ButtonSelect/ButtonSelect'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import LoadingLine from '~/Common-Objects/UI/Loading/LoadingLine'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import i18n from '~/i18n'
import Theme from '~/pages/cp/templates/add/dragDrop/themes/theme';
import InfiniteScroll from 'react-infinite-scroller';

class SavedThemes extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loaded: false,
            groups: [],
            templates: [],
            group: undefined,
            count: 0,
            selectedTemplate: undefined,
            limit: 6,
            page: 0,
            searchText: '',
            hasMore: false
        }

        this.getGroups = this.getGroups.bind(this);
        this.getTemplates = this.getTemplates.bind(this);
        this.select = this.select.bind(this);
        this.updateSearchText = this.updateSearchText.bind(this);
        this.selectGroup = this.selectGroup.bind(this);
    }

    componentDidMount() {
        this.getGroups()
    }

    getGroups() {
        axios.get('/templateGroup')
            .then(response => {
                this.setState({
                    groups: response.data.TemplateGroups.filter(g => g.id !== '-999')
                }, this.getTemplates)
            })
            .catch(console.log)
    }

    getTemplates(reload) {

        var queryStr = `?recordLimit=${this.state.limit}&startRecord=${reload ? 0 : this.state.templates.length}&sortColumn=id&sortOrder=desc`;
        if (this.state.searchText) queryStr += '&searchText=' + this.state.searchText;
        if (this.state.group) queryStr += '&groupID=' + this.state.group.id;
        axios.get('/template' + queryStr).then(response => {
            var templates = reload ? [] : this.state.templates;
            templates = templates.concat(response.data.Templates)
            this.setState({
                templates,
                count: response.data.countTotal,
                loaded: true,
                hasMore: templates.length < response.data.countTotal
            })
        })
    }

    select(template) {
        this.setState({
            selectedTemplate: template.id
        })
    }

    updateSearchText(ev) {
        this.setState({
            searchText: ev.currentTarget.value
        }, () => {
            if (this.timer) {
                clearTimeout(this.timer)
            }
            this.timer = setTimeout(() => this.getTemplates(true), 250)
        })
    }

    selectGroup(group) {
        this.setState({
            group
        }, () => this.getTemplates(true))
    }

    render() {
        if (!this.state.loaded) return <div style={{ marginTop: '50px' }}>
            <LoadingIcons iconType="2" className="mar-b30" />
        </div>

        let headerText = this.state.group ? this.state.group.groupName : "Filter By Template Group"
        if (headerText === 'deleted') {
            headerText = i18n.t('deleted')
        }

        const loader = <LoadingLine key={0}></LoadingLine>;
        return <div>
            <Row>

                <Column xs={12} sm={this.state.groups.length ? 6 : 12} className="mar-b25">
                    <TextInput
                        name="searchText"
                        clickToChangeClicked={this.getTemplates}
                        onEnterPress={this.getTemplates}
                        onChange={this.updateSearchText}
                        value={this.state.searchText}
                        style={{ paddingRight: "35px" }}
                        placeholder={i18n.t('campaigns:standard.step2.saved.search')}
                        iconLeft={<Icons icon="magnifier" onClick={() => { }} />}
                    />
                </Column>

                {!!this.state.groups.length && <Column xs={12} sm={6} className="quickFlex end-xs mar-b25">
                    <ButtonSelect
                        headerText={headerText} data={
                            [<a key={-1} onClick={() => this.selectGroup(undefined)}>All Templates</a>].concat(
                                this.state.groups.map((group, index) => {
                                    let name = group.groupName;
                                    if (name === 'deleted') {
                                        name = i18n.t('deleted')
                                    }
                                    return <a key={index} onClick={() => this.selectGroup(group)}>{name}</a>
                                }))
                        } />
                </Column>}
            </Row>


            <Paper className="mar-b25">
                <div ref={(ref) => this.scrollParentRef = ref}>
                    <InfiniteScroll
                        pageStart={0}
                        loadMore={() => this.getTemplates(false)}
                        hasMore={this.state.hasMore}
                        loader={loader}
                        useWindow={false}
                        getScrollParent={() => this.scrollParentRef}
                    >
                        <Row>
                            {!this.state.templates.length && <div style={{ width: '100%' }} className="center-xs center-sm center-md center-lg mar-t30"><span >{i18n.t('campaigns:standard.step2.saved.none')}</span></div>}
                            {this.state.templates.map((template, index) => {
                                return <Column xs={12} sm={6} md={4} lg={3} className="themes-advanced" key={index}>
                                    <Theme
                                        theme={template}
                                        className="extraSpace"
                                        selected={this.props.selectedId == template.id}
                                        select={() => this.props.onSelect(template)}
                                    />
                                </Column>
                            })}
                        </Row>
                    </InfiniteScroll>
                </div>
            </Paper>
        </div>
    }
}

export default SavedThemes;